<template>
  <div v-if="!isCancelled" class="flex items-center">
    <div v-if="stage!==5">
      <button @click="emitEvent('continue')" class="text-blue cursor-pointer outline-none">Continue</button>
      <button @click="emitEvent('cancel')" class="text-grey cursor-pointer outline-none ml-8">Cancel</button>
    </div>
    <div v-else>
      <button @click="emitEvent('view')" class="text-blue outline-none cursor-pointer">View</button>
      <button @click="emitEvent('download')" class="text-blue outline-none cursor-pointer ml-8">Download PDF</button>
    </div>
  </div>
  <div v-else-if="isCancelled === 'LOW SCORE'" class="flex items-center">
    <span class="text-grey">No action available</span>
  </div>
  <div v-else class="flex items-center">
    <button @click="emitEvent('tryAgain')" class="text-blue cursor-pointer outline-none">Try Again</button>
  </div>
</template>
<script>
export default {
  props: {
    stage: {
      type: Number,
      default () {
        return 1
      },
    },
    applicationId: {
      type: String,
      default () {
        return ''
      },
    },
    isCancelled: {
      type: String,
      default () {
        return ''
      },
    },
  },
  methods: {
    emitEvent(data) {
      this.$emit('componentEvent', { action: data, id: this.applicationId });
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/TableComponents/ActionCell.vue